import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/report/internal-report`;
const ACCOUNT_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/account`;
const PAYMENT_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/payment`;

const reportService = {
    async getSalesPerformanceReportOne(params: any) {
        return axios.get(`${GATEWAY_URL}/sales-performance-grid-report-one` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getSalesPerformanceReportFour(params: any) {
        return axios.get(`${GATEWAY_URL}/sales-performance-grid-report-four` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getSalesAmountByProductGroup(params: any) {
        return axios.get(`${GATEWAY_URL}/sales-amount-by-product-group?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getTopTenProducts(params: any) {
        return axios.get(`${GATEWAY_URL}/top-ten-products?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getSalesAmountTrend(params: any) {
        return axios.get(`${GATEWAY_URL}/sales-amount-trend?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getSalesQuantityTrend(params: any) {
        return axios.get(`${GATEWAY_URL}/sales-quantity-trend?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getAvgSalesPriceByCity(params: any) {
        return axios.get(`${GATEWAY_URL}/avg-sales-price-by-city?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getTotalSalesByMarket(params: any) {
        return axios.get(`${GATEWAY_URL}/total-sales-by-market?` + params)
        .then((response) => {
            return response.data;
        });
    },

    async getSupplierMontlySalesAmount() {
        return axios.get(`${GATEWAY_URL}/supplier-monthly-sales-amount`)
        .then((response) => {
            return response.data;
        });
    },

    async getSupplierProductCount() {
        return axios.get(`${GATEWAY_URL}/supplier-product-count`)
        .then((response) => {
            return response.data;
        });
    },

    async getSupplierRetailerCount() {
        return axios.get(`${GATEWAY_URL}/supplier-retailer-count`)
        .then((response) => {
            return response.data;
        });
    },

    async getSupplierSalesAmountByProductGroup() {
        return axios.get(`${GATEWAY_URL}/supplier-sales-amount-by-product-group`)
        .then((response) => {
            return response.data;
        });
    },

    async getSupplierActivities() {
        return axios.get(`${ACCOUNT_URL}/supplier-activities`)
        .then((response) => {
            return response.data;
        });
    },

    async getRetailerMontlySalesAmount() {
        return axios.get(`${GATEWAY_URL}/retailer-monthly-sales-amount`)
        .then((response) => {
            return response.data;
        });
    },

    async getRetailerProductCount() {
        return axios.get(`${GATEWAY_URL}/retailer-product-count`)
        .then((response) => {
            return response.data;
        });
    },

    async getRetailerSupplierCount() {
        return axios.get(`${GATEWAY_URL}/retailer-supplier-count`)
        .then((response) => {
            return response.data;
        });
    },

    async getRetailerSalesAmountByProductGroup() {
        return axios.get(`${GATEWAY_URL}/retailer-sales-amount-by-product-group`)
        .then((response) => {
            return response.data;
        });
    },

    async getRetailerActivities() {
        return axios.get(`${ACCOUNT_URL}/retailer-activities`)
        .then((response) => {
            return response.data;
        });
    },
    async getRetailerLastFiveBalance() {
        return axios.get(`${PAYMENT_URL}/retailer_last_five_balance`)
        .then((response) => {
            return response.data;
        });
    },
      async getSupplierMontlySalesQuantity() {
        return axios.get(`${GATEWAY_URL}/supplier-monthly-sales-quantity`)
        .then((response) => {
            return response.data;
        });
    },
}
export default reportService;